import { DecisionPage, DetectedDatesSummary } from "../../../models/home";
import { buildCompactAction, buildConfidence, buildPriority, buildRisk, buildSummary, isoFromNow } from "./home-qa-harness.builders";
import { BLOCKED_HERO, READY_HERO } from "./home-qa-harness.hero-fixtures";

export const ALL_DECISIONS_PAGE: DecisionPage = {
  items: [
    READY_HERO.decision!,
    BLOCKED_HERO.decision!,
    {
      decisionId: "decision-waiting",
      state: "waiting",
      title: "Await vendor confirmation",
      shortReason: "A third-party confirmation is still pending.",
      documentCount: 1,
      primaryDocument: {
        documentId: "doc-waiting",
        classificationId: "class-waiting",
        title: "Vendor confirmation chain"
      },
      nextBestAction: buildCompactAction("reopen_decision", "Reopen decision", true, {
        executionMode: "inspect"
      }),
      availableActions: [
        buildCompactAction("reopen_decision", "Reopen decision", true, {
          placement: "primary",
          executionMode: "inspect",
          refreshHints: ["detail", "activity"]
        })
      ],
      priority: buildPriority(58, "medium", "The deadline is still outside the 72h window."),
      risk: buildRisk("medium", "Delay is acceptable for now."),
      confidence: buildConfidence(0.86),
      missingInformationCount: 0,
      owner: { userId: "u-5", displayName: "Vendor Ops" },
      dueAt: isoFromNow(96),
      updatedAt: isoFromNow(-7),
      traceId: "trace-waiting"
    },
    {
      decisionId: "decision-safe",
      state: "act_without_rush",
      title: "Monitor renewal clause discrepancy",
      shortReason: "The discrepancy is below the intervention threshold, but you can reopen it if business context changes.",
      documentCount: 1,
      primaryDocument: {
        documentId: "doc-safe",
        classificationId: "class-safe",
        title: "Renewal clause discrepancy note"
      },
      nextBestAction: buildCompactAction("reopen_decision", "Reopen decision", true, {
        executionMode: "inspect"
      }),
      availableActions: [
        buildCompactAction("reopen_decision", "Reopen decision", true, {
          placement: "primary",
          executionMode: "inspect"
        })
      ],
      priority: buildPriority(28, "low", "The discrepancy is currently safe to observe."),
      risk: buildRisk("low", "No immediate business exposure is expected."),
      confidence: buildConfidence(0.88),
      missingInformationCount: 0,
      owner: { userId: "u-8", displayName: "Legal Watch" },
      dueAt: isoFromNow(144),
      updatedAt: isoFromNow(-12),
      traceId: "trace-safe"
    },
    {
      decisionId: "decision-complete",
      state: "completed",
      title: "Archive signed amendment",
      shortReason: "The amendment was archived and no further action is required.",
      documentCount: 1,
      primaryDocument: {
        documentId: "doc-complete",
        classificationId: "class-complete",
        title: "Signed amendment"
      },
      nextBestAction: buildCompactAction("reopen_decision", "Reopen decision", true, {
        executionMode: "inspect"
      }),
      availableActions: [
        buildCompactAction("reopen_decision", "Reopen decision", true, {
          placement: "primary",
          executionMode: "inspect"
        })
      ],
      priority: buildPriority(22, "low", "The work is already completed."),
      risk: buildRisk("low", "No remaining business exposure."),
      confidence: buildConfidence(0.97),
      missingInformationCount: 0,
      owner: { userId: "u-6", displayName: "Legal Archive" },
      dueAt: isoFromNow(240),
      updatedAt: isoFromNow(-24),
      traceId: "trace-complete"
    }
  ],
  summary: buildSummary(),
  filters: {},
  page: 1,
  pageSize: 10,
  totalItems: 5,
  totalPages: 1,
  hasMore: false,
  refreshedAt: isoFromNow(-1)
};

export const BLOCKED_DECISIONS_PAGE: DecisionPage = {
  items: [BLOCKED_HERO.decision!],
  summary: buildSummary(),
  filters: { state: "waiting" },
  page: 1,
  pageSize: 10,
  totalItems: 1,
  totalPages: 1,
  hasMore: false,
  refreshedAt: isoFromNow(-1)
};

export const EMPTY_DATES_SUMMARY: DetectedDatesSummary = {
  totalDetected: 0,
  byRole: {},
  roleLabels: {},
  monitoredDates: []
};

